import script from "./TotalHand.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalHand.vue?vue&type=script&setup=true&lang=js"

import "./TotalHand.vue?vue&type=style&index=0&id=4b16ab57&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b16ab57"]])

export default __exports__